import {
  Box,
  Button,
  Grid,
  TextField,
  Modal,
  ToggleButton,
  ToggleButtonGroup,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
} from "@mui/material";
import React, { useState } from "react";
import "./FinancialGoals.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setProductClass,
  setAnswers,
} from "../../features/FPSlice/financialPageSlice";
import Logo from "../../images/logo_quick-learning-tool.png";
import DaniloTag from "../../images/danilo-ipon_filipino-ver.png";
import LanieTag from "../../images/lanie-hiram_filipino-ver.png";
import PedroTag from "../../images/pedro-segurado_filipino-ver.png";
import { CancelRounded } from "@mui/icons-material";
import Swal from "sweetalert2";

function FinancialGoalsFil() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [inputValues, setInputValues] = useState({});
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [selectedLang, setSelectedLang] = useState("tagalog");

  const handleChange = (event, newValue) => {
    setSelectedValue(newValue);
  };

  const handleChangeInput = (event) => {
    const { name, value } = event.target;
    setInputValues({
      ...inputValues,
      [name]: value,
    });
  };

  const handleNext = () => {
    if (!selectedValue) {
      Swal.fire({
        icon: "error",
        title: "Hindi kumpleto patlang",
        text: "Pakikumpleto ang lahat ng kinakailangang patlang para magpatuloy",
        customClass: {
          popup: "custom-swal-popup",
          confirmButton: "custom-swal-button",
        },
      });
      return;
    }

    const requiredFields = {
      savings: ["savingsQ1", "savingsQ2"],
      loan: ["loanQ1", "loanQ2", "loanQ3"],
      insurance: ["insuranceQ1", "insuranceQ2"],
      others: ["otherQ1"],
    };

    const fieldsToCheck = requiredFields[selectedValue];

    if (
      !inputValues.mainQuestion ||
      fieldsToCheck.some((field) => !inputValues[field])
    ) {
      Swal.fire({
        icon: "error",
        title: "Hindi kumpleto patlang",
        text: "Pakikumpleto ang lahat ng kinakailangang patlang para magpatuloy",
        customClass: {
          popup: "custom-swal-popup",
          confirmButton: "custom-swal-button",
        },
      });
      return;
    }

    dispatch(setProductClass(selectedValue));
    dispatch(setAnswers(inputValues));
    navigate("/avatar/Fil");
  };

  const handleLangChange = (event) => {
    setSelectedLang(event.target.value);
  };

  const handleKeyPress = (e) => {
    const lowercaseKey = e.key.toLowerCase();

    if (lowercaseKey !== e.key) {
      e.preventDefault();
    }

    if (e.key === ".") {
      e.preventDefault();
    }
  };

  const handleLanguage = () => {
    navigate("/");
  };

  return (
    <Box>
      <Box className="main-card">
        <Grid container>
          <Grid item xs={12} md={3} className="left-card">
            <Box className="img-container">
              <img src={Logo} alt="Logo" className="logo-img" />
            </Box>
            <Box sx={{ margin: "1rem" }}>
              <Button
                sx={{
                  backgroundColor: "#06BCEE",
                  color: "#ffffff",
                  textTransform: "none",
                  padding: ".5rem",
                  width: "100%",
                  borderRadius: "2rem",
                  fontSize: "1.2rem",
                  "&:hover": {
                    backgroundColor: "#06BCEE", // Set it to the same value as the default
                  },
                }}
                onClick={() => handleLanguage()}
              >
                To English Ver.
              </Button>
            </Box>
            <Box className="instruction-card">
              <p className="instruction-title">Gabay</p>
              <p className="instruction-text">
                Ang isang empowered customer ay may tiyak na layuning pinansyal
                na kaugnay sa pangarap niyang maging financially independent.
              </p>
              <p className="instruction-text">
                Mayroon siyang plano ng aksyon na tumutukoy sa kinakailangang
                halaga at mga produktong pinansyal upang makamit ang layunin.
              </p>
              <p className="instruction-text">
                Gawin ang pagsasanay sa Paggawa ng Avatar upang matulungan kang
                magtakda ng layuning pampinansyal at tukuyin ang produktong
                pinansyal na kailangan mo.
              </p>
            </Box>
          </Grid>
          <Grid item xs={12} md={9} className="right-card">
            <Box className="fgMain-card">
              <Box sx={{ padding: "1rem" }}>
                <h1 style={{ fontSize: "2.5rem", padding: "1rem" }}>
                  Mayroon ka bang layuning pinansyal?
                </h1>
                <p className="link-text" onClick={() => handleOpen()}>
                  Tingnan ang mga halimbawa
                </p>
                <Box className="main-question-card">
                  <Box className="question-card">
                    <p className="english-text">
                      Sa loob ng dalawang (2) taon, ano ang gusto mong mangyari
                      sa iyong buhay pinansyal?
                    </p>

                    <TextField
                      variant="standard"
                      name="mainQuestion"
                      InputProps={{
                        disableUnderline: true,
                      }}
                      className="textField"
                      placeholder="I-type ang iyong sagot dito…"
                      onChange={handleChangeInput}
                      onKeyPress={handleKeyPress}
                    />
                  </Box>
                  <Box className="question-card">
                    <p className="english-text">
                      Anong pinansyal na produkto o serbisyo ang makakatulong sa
                      iyo upang makamit mo ang iyong financial goals?
                    </p>

                    <Box
                      display="flex"
                      flexDirection="row"
                      sx={{ marginTop: "1rem" }}
                    >
                      <ToggleButtonGroup
                        value={selectedValue}
                        exclusive
                        onChange={handleChange}
                        fullWidth
                      >
                        <ToggleButton value="savings" className="root">
                          Savings
                        </ToggleButton>
                        <ToggleButton value="loan" className="root">
                          Loan
                        </ToggleButton>
                        <ToggleButton value="insurance" className="root">
                          Insurance
                        </ToggleButton>
                        <ToggleButton value="others" className="root">
                          Iba pa
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </Box>
                  </Box>
                  {selectedValue === "savings" && (
                    <>
                      <Box className="question-card">
                        <p className="english-text">
                          Magkano ang kabuuang halaga na gusto mong pag-ipunan?
                        </p>

                        <TextField
                          variant="standard"
                          name="savingsQ1"
                          InputProps={{
                            disableUnderline: true,
                          }}
                          className="textField"
                          placeholder="I-type ang iyong sagot dito…"
                          onChange={handleChangeInput}
                          type="number"
                          onKeyPress={handleKeyPress}
                        />
                      </Box>
                      <Box className="question-card">
                        <p className="english-text">
                          Magkano ang kaya mong ipon kada buwan?
                        </p>

                        <TextField
                          variant="standard"
                          name="savingsQ2"
                          InputProps={{
                            disableUnderline: true,
                          }}
                          className="textField"
                          placeholder="I-type ang iyong sagot dito…"
                          onChange={handleChangeInput}
                          type="number"
                          onKeyDown={handleKeyPress}
                        />
                      </Box>
                    </>
                  )}
                  {selectedValue === "loan" && (
                    <>
                      <Box className="question-card">
                        <p className="english-text">
                          Para saan ang loan na gusto mong makuha?
                        </p>

                        <TextField
                          variant="standard"
                          InputProps={{
                            disableUnderline: true,
                          }}
                          className="textField"
                          placeholder="I-type ang iyong sagot dito…"
                          name="loanQ1"
                          onChange={handleChangeInput}
                          onKeyPress={handleKeyPress}
                        />
                      </Box>
                      <Box className="question-card">
                        <p className="english-text">
                          Magkano ang loan na ninanais mo?
                        </p>

                        <TextField
                          variant="standard"
                          InputProps={{
                            disableUnderline: true,
                          }}
                          className="textField"
                          placeholder="I-type ang iyong sagot dito…"
                          name="loanQ2"
                          onChange={handleChangeInput}
                          onKeyPress={handleKeyPress}
                          type="number"
                        />
                      </Box>
                      <Box className="question-card">
                        <p className="english-text">
                          Sa iyong palagay, gaano katagal mo ito mababayaran?
                        </p>

                        <TextField
                          variant="standard"
                          InputProps={{
                            disableUnderline: true,
                          }}
                          className="textField"
                          placeholder="I-type ang iyong sagot dito…"
                          name="loanQ3"
                          onChange={handleChangeInput}
                          onKeyPress={handleKeyPress}
                        />
                      </Box>
                    </>
                  )}
                  {selectedValue === "insurance" && (
                    <>
                      <Box className="question-card">
                        <p className="english-text">
                          Anong klaseng insurance ang gusto mong makuha?
                        </p>

                        <TextField
                          variant="standard"
                          InputProps={{
                            disableUnderline: true,
                          }}
                          className="textField"
                          placeholder="I-type ang iyong sagot dito…"
                          name="insuranceQ1"
                          onChange={handleChangeInput}
                          onKeyPress={handleKeyPress}
                        />
                      </Box>
                      <Box className="question-card">
                        <p className="english-text">
                          Magkano ang premium na kaya niyo bayaran?
                        </p>

                        <TextField
                          variant="standard"
                          InputProps={{
                            disableUnderline: true,
                          }}
                          className="textField"
                          placeholder="I-type ang iyong sagot dito…"
                          name="insuranceQ2"
                          onChange={handleChangeInput}
                          onKeyPress={handleKeyPress}
                          type="number"
                        />
                      </Box>
                    </>
                  )}
                  {selectedValue === "others" && (
                    <>
                      <Box className="question-card">
                        <p className="english-text">Pakitukoy</p>
                        <TextField
                          variant="standard"
                          InputProps={{
                            disableUnderline: true,
                          }}
                          className="textField"
                          placeholder="I-type ang iyong sagot dito…"
                          name="otherQ1"
                          onChange={handleChangeInput}
                          onKeyPress={handleKeyPress}
                        />
                      </Box>
                    </>
                  )}
                </Box>
              </Box>
            </Box>
            <Box className="button-container">
              <Button className="next-button" onClick={() => handleNext()}>
                Sunod
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Modal open={open} onClose={handleClose} className="fgExample-main">
        <Box className="fgExample-modal">
          <Grid container>
            <Grid item xs={12}>
              <CancelRounded
                sx={{
                  float: "right",
                  fontSize: 45,
                  color: "#D9D9D9",
                  marginTop: "-.5rem",
                  cursor: "pointer",
                }}
                onClick={() => handleClose()}
              />
            </Grid>
            {selectedLang === "tagalog" && (
              <>
                <Grid item xs={12} md={4}>
                  <Box className="img-container">
                    <img
                      src={DaniloTag}
                      alt="example"
                      className="example-img"
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box className="img-container">
                    <img src={LanieTag} alt="example" className="example-img" />
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box className="img-container">
                    <img src={PedroTag} alt="example" className="example-img" />
                  </Box>
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      </Modal>
    </Box>
  );
}

export default FinancialGoalsFil;
